<template>
  <div class="xin">
    <div class="switch">
      <el-tabs v-model="activeName" @tab-click="edit_list">
        <!-- 邮件限制列表 -->
          
        <el-tab-pane label="邮件限制列表" v-if="this.user_list==true" name="first">
          <span slot="label">
            {{ $t("logs.role1") }}
          </span>
          <div class="switch1">
            <!-- 弹出框2-->

            <!--  表格 -->
            <div class="table table loading_text">
              <el-table
                v-loading="load_role"
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList1"
                :row-class-name="tableRowClassName"
                :cell-class-name="tableCellClassName"
              >
                <el-table-column prop="ROLE_NAME" :label="$t('logs.role2')">
                </el-table-column>

                <el-table-column
                  prop="ROLE_NAME"
                  :label="$t('logs.audit6')"
                  width="400"
                >
                  <template slot-scope="scope">
                    <!-- 编辑审核流程-->

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      @click="bianji1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("logs.ldap21") }}</el-button
                    >
                    <!-- 删除-->

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      class="iddefault"
                      >{{ $t("table1.delete") }}</el-button
                    >
                    <!-- 将角色赋予用户-->

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      @click="edit_roles_to_user(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >{{ $t("logs.mode_switch10") }}</el-button
                    >
                  </template>
                  <!-- 快编辑审核策略-->
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>

        <!-- 添加邮件 -->

        <el-tab-pane label="1" v-if="this.user_add_edit==true" name="two">
          <span slot="label" >
           <span v-if="this.user_list==true">{{ $t("logs.role3") }}</span> 
           <span v-if="this.edit_user==true">{{ $t("logs.role5") }}</span> 
          </span>
         
          <div class="switch1">
            <div class="lie">
              <table>
                <!-- 创建角色:-->
                <p class="create_information" v-if="this.user_list==true">{{ $t("logs.role3") }}</p>
                <tbody v-if="this.user_list==true">
                 
                  <tr >
                    <td>{{ $t("logs.role2") }}:</td>
                    <td>
                      <el-input
                        v-model="maillistname"
                        placeholder
                        clearable
                      ></el-input>
                    </td>
                  </tr>
                </tbody>
                  <p class="create_information" v-if="this.edit_user==true">{{ $t("logs.role5") }}</p>
                  <tbody v-if="this.edit_user==true">
                     <tr >
                    <td>{{ $t("logs.role2") }}:</td>
                    <td>
                      <span
                        style="
                          text-align: left;
                          color: #0e2c5e;
                          line-height: 32px;
                        "
                        >{{ this.maillistname }}</span
                      >
                    </td>
                  </tr>
                </tbody>
                <!--  角色权限设置-->
                <p class="create_information">{{ $t("logs.role6") }}</p>
               <tbody>
                  <tr>
                    <td>{{ $t("logs.menu_judge") }}:</td>
                    <td>
                      <el-tree
                        :data="menu"
                        ref="tree_add"
                        :show-checkbox="true"
                        node-key="id"
                        :check-strictly="true"
                       @check="checkChange"
                        @check-change="handleSelectionChange"
                        :default-checked-keys="resourceCheckedKey"
                        default-expand-all
                        :props="defaultProps"
                      >
                      </el-tree>
                    </td>
                  </tr>
                </tbody>
                <!-- 操作权限 -->
                <tbody>
                  <tr>
                    <td>{{ $t("logs.Policy_list19") }} :</td>
                    <td style="flex:1">
                      <!-- 策略权限 -->

                      <el-checkbox
                        :indeterminate="isIndeterminate"
                        v-model="checkAll"
                        @change="handleCheckAllChange"
                        style="padding: 6px 0"
                        >{{ $t("logs.report13") }}</el-checkbox
                      >

                      <el-checkbox-group
                        v-model="common"
                        @change="handleCheckedCitiesChange"
                        style="
                          display: flex;
                          flex-wrap: wrap;
                          padding-bottom: 6px;
                        "
                      >
                        <el-checkbox
                          v-for="v in policy_priv_add_arr"
                          :label="v.key"
                          :key="v.key"
                          class="policy_priv_role"
                          >{{ v.label }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr>
                    <td></td>
                    <td style="display: flex; flex-direction: row" v-if="this.user_list==true">
                      <el-button
                        type="primary"
                        @click="save_user"
                        :disabled="$root.jurisdiction.only_query == 0"
                        >{{ $t("logs.save_a") }}</el-button
                      >
                    </td>
                      <td style="display: flex; flex-direction: row" v-if="this.edit_user==true">
                      <el-button type="primary" @click="edit_save_user">{{
                        $t("logs.save_a")
                      }}</el-button>
                      <el-button type="danger" @click="off_user">{{
                        $t("logs.save_b")
                      }}</el-button>
                    </td>
                  </tr>
                
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
         <!-- 将角色赋予用户 -->
        <el-tab-pane label="label1" v-if="this.roles_to_user==true" name="three">
          <span slot="label">
            {{ $t("logs.mode_switch12") }}
          </span>
          <div class="switch1">
            <div class="lie">
              <table>
                <tbody>
                  <tr>
                    <td>{{ $t("logs.role2") }}:</td>
                    <td>
                      <span
                        style="
                          text-align: left;
                          color: #0e2c5e;
                          line-height: 32px;
                        "
                        >{{ this.maillimit_user }}</span
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t("logs.mode_switch12") }}:</td>
                    <td style="width: 50%">
                      <el-input
                        type="textarea"
                        :autosize="{ minRows: 10 }"
                        placeholder="请输入内容"
                        v-model="cgi_owneres"
                      >
                      </el-input>
                    </td>
                  </tr>
                  <tr>
                    <td></td>
                    <td style="display: flex; flex-direction: row">
                      <el-button
                        type="primary"
                        @click="save_edit_roles_to_user"
                        >{{ $t("logs.save_a") }}</el-button
                      >
                      <el-button type="danger" @click="off_roles_to_user">{{
                        $t("logs.save_b")
                      }}</el-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
     
     
     
     
    </div>
    <!-- 查询框 -->

    <!--  底部 -->
  </div>
</template>

<script>
import { admentrole_get } from "@/tool/api.js";
export default {
  data() {
    return {
      activeName:'first',
      isIndeterminate: false,
      checkAll: [],

      policy_priv_add_arr: [],
      role_user: 1,
      // 该数组是选中的节点(半选的节点和全选的节点全都存储在这个数组)
      multipleSelection: [],
      // 该数组回显数据根据所对应的ID  进行默认勾选 (:default-checked-keys 这个) 和 (node-key="id") 这个两个并存
      resourceCheckedKey: [],
      resourceCheckedKey_daf: [],
      menu: [],
      common: [],
      common_daf: [],
      tree_information: 0,
      defaultProps: {
        children: "children",
        label: "label",
      },
      cgi_owneres: "",
      role_id: "",
      roles_to_user: false,
      fm_readonly: false,

      audit_man: false,
      archive_recover: false,
      archive_down: false,
      archive_view: false,
      view_snap: false,
      maillimit_user: "",
      limit_rcv_on: false,
      limit_rcv_adv_on: false,
      rcv_only_include: 0,
      rcv_dnes: "",
      limit_send_on: true,
      limit_send_adv_on: false,
      send_only_include: 0,
      send_dnes: "",

      mail_name: "6",
      add_show_hint1: "",
      add_show_hint2: "",
      maillistname: "",
      mltype: "",
      mltype_arr: [],
      description: "",
      mail_depart_id: "",
      outerusers: "",
      innerusers: "",
      mail_auths: "",
      mail_admins: "",
      notice_subject: "",
      notice_body: "",
      allow_ip: "",
      passwd2: "",
      passwd1: "",
      relation_email: "",
      admin: "",
      edit_user: false,
      user_add_edit:true,
      user_list: true,
      xian: false,

      value: "",

      tanchu: false,

      emali: "",
      fileList1: [],
      loading: false,
      load_role: false,
      ADD_ON: "",
      multi_address_hint: "",
      pwd_hint: "",
    };
  },
  mounted() {
    this.getFileList1();
    this.getFileList_add_role();
  },
  methods: {
    // 策略权限 全选
    handleCheckAllChange(val) {
      console.log(val);
      this.common = val ? this.policy_priv_add_arr.map((ele) => ele.key) : [];
      this.isIndeterminate = false;
      // this.isArr_priv();
    },
    // 策略权限 单选
    handleCheckedCitiesChange(value) {
      console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.policy_priv_add_arr.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.policy_priv_add_arr.length;

      // this.isArr_priv();
    },

    // el-tree 复选框默认选中事件
    handleSelectionChange(data, checked) {
      // console.log(data, checked);
      if (checked == false) {
        data.select = 0;
      } else {
        data.select = 1;
      }
    },
    // 遍历找出所有子节点
    findAllChildren(data) {
      // console.log(data);
      let arr_push = [];
      let arr_tow_push = [];
      data.forEach((item) => {
        // console.log(item, "每个的值");
        if (item.select == "1") {
          arr_push.push(item.id);
        }
        if (item.children) {
          item.children.forEach((value) => {
            // console.log(value);
            if (value.select == "1") {
              arr_tow_push.push(value.id);
            }
          });
        }

        // console.log(this.resourceCheckedKe, arr_push, "循环里", arr_tow_push);
      });

      this.resourceCheckedKey = [...arr_push,...arr_tow_push];
      // console.log(this.resourceCheckedKe, arr_push);
    },
    // 通过check的回调里面获取节点id,再获取节点的node对象,这是复选框选中
    checkChange(data) {
      // console.log(data);
      const node = this.$refs.tree_add.getNode(data.id);
      // console.log(node)
      this.setNode(node);
    },
    //递归设置子节点和父节点
    setNode(node) {
      // console.log(node, "node", node.checked);
      if (node.checked) {
        //如果当前是选中checkbox,则递归设置父节点和父父节点++选中
        this.setParentNode(node);
      } else {
        //如果当前是取消选中checkbox,则递归设置子节点全部取消选中
        this.setChildNode(node);
      }
    },
    //递归设置父节点全部选中
    setParentNode(node) {
      if (node.parent) {
        for (const key in node) {
          if (key === "parent") {
            node[key].checked = true;
            this.setParentNode(node[key]);
          }
        }
      }
    },
    //递归设置子节点全部取消选中
    setChildNode(node) {
      // console.log(node, "这是那个");
      if (node.childNodes && node.childNodes.length) {
        node.childNodes.forEach((item) => {
          item.checked = false;
          this.setChildNode(item);
        });
      }
    },

    // 设置角色管理对象 roles_to_user
    edit_roles_to_user(index, scope) {
      // console.log(index, scope);
      // this.admin = scope.USERNAME
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      this.role_id = scope.ROLE_ID;
      this.$axios
        .get("/api/adm/cgi/admentrole.cgi", {
          params: {
            __mode: "set_newrole_owner",
            sid: sid,
            role_id: scope.ROLE_ID,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.activeName="three"
            this.user_list = false;
            this.user_add_edit = false;
            this.roles_to_user = true;
            this.loading = false;
            this.maillimit_user = res.data.ret.ROLE_NAME;
            this.cgi_owneres = res.data.ret.CGI_OWNERES;

            // this.getFileList();
          }
        });
    },
    // 保存角色管理对象 roles_to_user
    save_edit_roles_to_user() {
      // console.log(index, scope);
      // this.admin = scope.USERNAME
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      this.$axios
        .get("/api/adm/cgi/admentrole.cgi", {
          params: {
            __mode: "save_newrole_owner",
            sid: sid,

            role_id: this.role_id,
            cgi_owneres: this.cgi_owneres,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            // this.getFileList();
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.user_list = true;
            this.user_add_edit=true
            this.roles_to_user = false;
            this.loading = false;
            this.activeName='first'
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
            // this.getFileList();
          }
        });
    },
    // 判断状态变色
    tableCellClassName({ row }) {
      // console.log(row);

      if (row.ISDEFAULT == "是") {
        return "sent1";
      }
      return "";
    },
    edit_list(a) {
      console.log(a.index);
      if (a.index == 1) {
        this.admin = "";
        this.maillistname='';
        this.common=this.common_daf;
       this.checkAll = this.common.length === this.policy_priv_add_arr.length;
      this.isIndeterminate =
        this.common.length > 0 && this.common.length < this.policy_priv_add_arr.length;
  // this.resourceCheckedKey=this.resourceCheckedKey_daf;

        this.$refs.tree_add.setCheckedKeys(this.resourceCheckedKey_daf)

       
      }
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 角色列表加载
    getFileList1() {
      admentrole_get({
        __mode: "list_new_role",
      }).then((res) => {
        // console.log(res, "有来这里吗");

        console.log(888, this.loading);

        this.fileList1 = res.ret.datalist;
      });
    },
    // 添加角色
    getFileList_add_role() {
      // this.loading = true;

      admentrole_get({
        __mode: " load_priv_list",
      }).then((res) => {
        console.log(res);
        // this.loading = false;
        console.log(77, this.loading);
        this.menu = res.ret.menu;
        this.menu_default  =JSON.parse(JSON.stringify(this.menu)) ;
        this.policy_priv_add_arr = res.ret.common;
        this.resourceCheckedKey_daf=res.ret.init_menu;
        this.common_daf=  res.ret.init_priv;
      });
    },

    // 编辑管理员保存
    edit_save_user() {
     
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let menu_arr = JSON.stringify(this.menu);
      let common_arr = JSON.stringify(this.common);
      let str = this.$qs.stringify({
        __mode: "save_new_role",
        sid: sid,

        role_name: this.maillistname,
        menu: menu_arr,
        common: common_arr,
        role_id: this.role_id,
      });
      // console.log(str, this.role_id);
      this.$axios
        .post(
          "/api/adm/cgi/admentrole.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          // console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            // this.loading = false;

            this.edit_user = false;
            this.user_list = true;
            this.activeName="first"
            // console.log(this.policy_priv_add_arr)
            setTimeout(() => {
              this.getFileList1();
            }, 10);
            

            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
          }
        });
    },
    isArr_priv() {
      this.menu.forEach((value) => {
        console.log(value);
        // value.value = 1;
        value.select = 0;
      });
      let a = this.menu;
      this.menu = a;
    },
    // 新增管理员保存
    save_user() {
      // this.loading = true;
      // this.tanchu = false
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(this.menu);
      let menu_arr = JSON.stringify(this.menu);
      let common_arr = JSON.stringify(this.common);

      let str = this.$qs.stringify({
        __mode: "save_new_role",
        sid: sid,
        role_name: this.maillistname,
        menu: menu_arr,
        common: common_arr,
        // data_loadok: this.data_loadok_smtp
      });
      // console.log(str)
      this.$axios
        .post(
          "/api/adm/cgi/admentrole.cgi",
          str
          // screen: "real_filterlog.html",
        )
        .then((res) => {
          console.log(res);

          if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.user_list = true;
            this.edit_user = false;
            this.loading = false;
            (this.maillistname = ""), (this.common = []);
            this.isIndeterminate = false;
            this.resourceCheckedKey=[];
            this.$refs.tree_add.setCheckedKeys([]);
            this.activeName='first'
          // this.menu=[]
          // setTimeout(() => {
          // this.menu=this.menu_default
            
          // }, 10);
          
            this.getFileList1();
            this.$message({
              type: "success",
              message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
            });
         
            //   this.$router.push({
            //     name: "login",
            // });
          }
        });
    },
    // 编辑更改密码1
    bianji1(index, scope) {
      console.log(index, scope);
      let jurisdiction = JSON.parse(scope.PRIV_JSON_STR);
      console.log(JSON.parse(scope.PRIV_JSON_STR));
      (this.maillistname = scope.ROLE_NAME), (this.role_id = scope.ROLE_ID);
      
      this.menu = jurisdiction.menu[0];
    
      this.findAllChildren(this.menu);

      this.common = jurisdiction.common[0];
    console.log(this.common);
    this.checkAll = this.common.length === this.policy_priv_add_arr.length;
       this.isIndeterminate = this.common.length > 0 && this.common.length  < this.policy_priv_add_arr.length;
        console.log(this.checkAll,this.isIndeterminate ,'这是什么呢', this.common.length ,this.policy_priv_add_arr.length)
    this.activeName='two'
      this.edit_user = true;
      this.user_list = false;
    },
    // 删除1
    handleClick1(index, scope) {
      // console.log(index, scope);
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

          this.$axios
            .get("/api/adm/cgi/admentrole.cgi", {
              params: {
                __mode: "del_new_role",
                sid: sid,
                role_id: scope.ROLE_ID,
              },
            })
            .then((res) => {
              // console.log(res);

              if (!res.data.fmstatus) {
                alert(res.data);
              } else if (res.data.fmstatus.code == "1") {
                alert(res.data.fmstatus.errmsg);
              } else if (res.data.fmstatus.code == "2") {
                alert(res.data.fmstatus.errmsg);
                // this.getFileList();
              } else if (res.data.fmstatus.code == "3") {
                alert(res.data.fmstatus.errmsg);
                this.$router.push({
                  name: "login",
                });
              } else {
                this.loading = false;
                this.getFileList1();
                this.$message({
                  type: "success",
                  message: `${this.$t("anti_gs1_tan.del1")}`,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
      this.tanchu1 = false;
    },
    tan4: function () {
      this.tanchu = true;
      //   this.tanchu1 = false;
    },
    tanOff: function () {
      this.tanchu = false;
      //   this.tanchu1 = false;
    },
    off_user: function () {
      this.activeName='first'
      this.user_list = true;
      this.edit_user = false;
    },
    off_roles_to_user: function () {
      this.activeName="first"
      this.user_list = true;
      this.user_add_edit=true
      this.roles_to_user = false;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";

/deep/ .table .el-table {
  height: calc(100vh - 180px);
}
/deep/ .has-gutter th {
  text-align: left;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: left;
}

.main-find {
  width: 100%;
  height: 50px;
  padding-left: 10px;
  // padding-bottom: 5px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: left;

  border: 2px solid #d2d7e6;
  background: #ffffff;

  span {
    margin-right: 8px;

    // width: 126px;
    // display: inline-block;
    color: #0e2c5e;
  }

  .el-input {
    margin-right: 8px;
    width: 20%;
    line-height: 26px;
    height: 26px;
    // padding: 5px 10px 5px 0;
  }

  // input 框高度
  /deep/ .el-input__inner {
    height: 32px;
    padding: 0 6px;
  }

  /deep/ .el-input--suffix {
    width: 150px;
    margin-right: 10px;
  }

  /deep/ .el-button {
    margin-right: 10px;
    margin-left: 30px;
  }
}

/deep/ .sent1 .iddefault {
  // color: #f00 !important;
  display: none;
}

/deep/ .el-input__suffix {
  right: 14px;
}
.pass_word {
  flex: 1;
}
/deep/.el-tabs--top .el-tabs__item.is-top:nth-child(2) {
  padding-left: 44px;
}
.el-checkbox {
  display: flex;
  align-items: center;
}
.el-radio {
  color: #0e2c5e;
}
.create_information {
  // margin: 0 14px;
  text-align: left;
  // padding-left: 14px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #0e2c5e;
  // background: #ffffff;
  // border: 2px solid #d2d7e6;
  border-bottom: 0;
  line-height: 40px;
  margin: 0 0px 0px 14px;
}
.policy_priv_role {
  width: 15%;
}
</style>
